import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface NewComplexGasConnectionProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  linksList?: LinksProps[];
  applyButton?: LinkButtonProps;
  faqs?: FaqAccordionGroupProps;
}

export const NewComplexGasConnection: React.FC<NewComplexGasConnectionProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  linksList,
  applyButton,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {lists && lists[1] && <List {...lists[1]} />}
      {applyButton && <LinkButton {...applyButton} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
